import { render } from "./PlanTableDropdown.vue?vue&type=template&id=01c6d4b9"
import script from "./PlanTableDropdown.vue?vue&type=script&lang=js"
export * from "./PlanTableDropdown.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__